import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IMLModelStatus, IMLPrediction, IMLSummary} from "../../../models/IMLMonitor";
import {fetchMLStatus, markPredictionRead} from "./actions";

interface IMLMonitorState {
    summary: IMLSummary | null;
    models: IMLModelStatus[];
    predictions: IMLPrediction[];
    loading: boolean;
    error: string | null;
    lastUpdated: string | null;
}

const initialState: IMLMonitorState = {
    summary: null,
    models: [],
    predictions: [],
    loading: false,
    error: null,
    lastUpdated: null,
};

export const MLMonitorSlice = createSlice({
    name: "ml_monitor",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMLStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMLStatus.fulfilled, (state, action) => {
                state.summary = action.payload.summary;
                state.models = action.payload.models;
                state.predictions = action.payload.predictions;
                state.loading = false;
                state.lastUpdated = new Date().toISOString();
            })
            .addCase(fetchMLStatus.rejected, (state, action) => {
                state.loading = false;
                if (action.meta.aborted) return;
                state.error =
                    typeof action.payload === "string"
                        ? action.payload
                        : "Ошибка загрузки ML-статуса";
            })

            .addCase(markPredictionRead.fulfilled, (state, action: PayloadAction<string>) => {
                const prediction = state.predictions.find(p => p.id === action.payload);
                if (prediction) {
                    prediction.is_notified = true;
                }
                if (state.summary) {
                    state.summary.unread_anomalies = Math.max(
                        0,
                        state.summary.unread_anomalies - 1
                    );
                }
            });
    },
});

export default MLMonitorSlice.reducer;
